import React, { ComponentType, FC } from 'react';

import { useRouter } from 'react-resource-router';

import { useHistory__UNSAFE } from 'src/router/hooks';
import { RouteComponentProps } from 'src/router/types';

// @ts-ignore TODO: fix noImplicitAny error here
const getDisplayName = c => c.displayName || c.name || 'Component';

export default function withLocation<T>(
  WrappedComponent: ComponentType<RouteComponentProps & T>
): ComponentType {
  const WithLocation: FC<RouteComponentProps & T> = props => {
    const [{ match, location }] = useRouter();
    const history = useHistory__UNSAFE();
    return (
      <WrappedComponent
        {...props}
        match={match}
        location={location}
        history={history}
      />
    );
  };

  WithLocation.displayName = `WithLocation(${getDisplayName(
    WrappedComponent
  )})`;

  return WithLocation;
}
